exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".message-box-container{position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,.2);z-index:16}.message-box{left:50%;border-radius:5px;box-shadow:0 1px 8px;width:250px;transform:translate(-50%, -100%)}.message-box,.message-box-close-button{position:absolute;top:50%;background:#fff}.message-box-close-button{border:none;outline:0;border-radius:50%;transition:transform(-50%, 0);transform:translateY(-50%);right:0;font-size:10px;color:#4c97e3}.message-box-close-button:hover{color:#ccc}.message-box-title{font-size:1pc;background:#4c97e3;border-radius:5px 5px 0 0;color:#fdf3f3;padding:10px;margin:0;position:relative;text-align:center}.message-box-body{padding:20px;line-height:1.5em;color:#333;word-break:break-all}.message-box-actions{padding:10px}.message-box-actions .btn-secondary{color:#a5a5a5;border-color:#ccc;background-color:transparent}.message-box-actions .btn-secondary:hover{background-color:#ccc;color:#000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/stylesheets/messageBox.css
 ** module id = 805
 ** module chunks = 73
 **/